import '.e0{font-size:1.125rem;}.ssr-plugin'
import '.eq{line-height:1.75rem;}.ssr-plugin'
import '.fi{text-decoration:none;}.ssr-plugin'
import '.fz{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e0 eq"
    >
      {translations.privacySubtitle}{' '}
      <a className="fi fz"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="fi fz"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
